import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import Box from '@mui/material/Box';
import { animated, useSpring } from '@react-spring/web';
import React from 'react';
import { appTheme } from '../theme';

export function BackToTop(props: {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  // Display full width without spacing for left side navigation
  fullWidth?: boolean;
}) {
  // Hooks
  const values = useSpring({
    opacity: 1,
    transform: 'translate3d(0, 0, 0)',
    from: { opacity: 0, transform: 'translate3d(0, 10px, 0)' },
  });

  return (
    <Box
      sx={{
        position: 'fixed',
        left: { xs: 15, md: props.fullWidth ? 15 : appTheme.drawerWidth + 15 },
        bottom: { xs: 75, md: 15 },
        zIndex: 999999,
      }}
    >
      <animated.button
        aria-label="back to top"
        style={{
          backgroundColor: '#fff',
          cursor: 'pointer',
          height: 45,
          width: 45,
          borderRadius: 50,
          border: '1px solid #b1b1b1',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          ...values,
        }}
        onClick={props.onClick}
      >
        <ArrowCircleUpIcon fontSize="large" color="primary" />
      </animated.button>
    </Box>
  );
}
